import { isString, parseStringRecord, StringRecord } from "./storageValidation";

const NOTES_KEY = "kanalearn.kanjiMemoryNotes.v1";
export type KanjiMemoryNotes = StringRecord<string>;

export function getNotes(): KanjiMemoryNotes {
    try {
        const raw = localStorage.getItem(NOTES_KEY);
        return parseStringRecord(raw, isString);
    } catch {
        return {};
    }
}

export function setNotes(notes: KanjiMemoryNotes): void {
    try {
        localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
    } catch {
        // Best-effort: if storage is unavailable, notes just won't persist.
    }
}
